module.exports = __webpack_public_path__ + "static/contribution_img4@2x-9061d753bdce6250c0b6d53c185797a4.jpg";